import * as Yup from 'yup';

const chainNum = Yup.number()
  .typeError('Número invalido.')
  .positive('Requiere ser positivo.')
  .integer('Requiere ser entero.')
  .required('Requerido.');

const chainName = Yup.string()
  .max(128, 'Requiere máximo 128 caracteres.')
  .notOneOf(['n/a', 'N/A'], 'Nombre invalido.')
  .trim()
  .required('Requerido.');

const agents = Yup.array()
  .of(Yup.object())
  .min(1, 'Requiere mínimo un agente.')
  .required('Requerido.');

const isActive = Yup.bool().required();

export const CHAIN_ADD_SCHEMA = Yup.object().shape({
  chainNum,
  chainName,
  agents,
});

export const CHAIN_EDIT_SCHEMA = Yup.object().shape({
  chainNum,
  chainName,
  agents,
  isActive,
});
